const NS = 'CareersGalleryBlock';
const CLS = 'careersGalleryBlock';

import Swiper from 'swiper/swiper-bundle.js';

export class CareersGalleryBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$buttons = this.$element.find('.tab-button');
		this.$carousels = this.$element.find('.gallery-swiper');
		this.$circleText = this.$element.find('.career-circle-text');
		this.itemsSlide = this.$element.data('itemsSlide');
		this.swipers = [];
		this.$circleText.css("background", "unset");
		this.initSwipers();
		this.bindEvents();
	}

	initSwipers() {
		this.$carousels.each((i, el) => {
			const swiper = new Swiper(el, {
				slidesPerView: this.itemsSlide,
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: this.itemsSlide, // 默认值用于大屏
					},
					0: {
						slidesPerView: 1,
					}
				},
				spaceBetween: 10,
			});
			this.swipers.push(swiper);
		});
	}

	bindEvents() {
		this.$buttons.on('click', (e) => {
			this.$circleText.css("background", "#fff");
			const $btn = $(e.currentTarget);
			$btn.find('.extra').hide();
			const index = $btn.data('index');
			const heading = $btn.find('.extra').html();
			this.$element.find('.circle-sub').html(heading);

			this.$buttons.removeClass('active');
			$btn.addClass('active');
			this.$carousels.hide();
			this.$carousels.filter(`[data-index=${index}]`).show();
			this.swipers[index].update();
		});
	}
}

